import React, { Fragment } from 'react';
import ClientManagerCasesDetailContainer from 'src/ui/features/Cases/containers/ClientManagerCasesDetailContainer';

function CasesDetailsPres(props) {
  const { isCorpClient, isRestrictedCorpMember } = props;
  return <Fragment>{(isCorpClient || isRestrictedCorpMember) && <ClientManagerCasesDetailContainer {...props} />}</Fragment>;
}

export default CasesDetailsPres;
